export enum AccountStatus {
  OfferPending = 'OFFER_PENDING',
  Frozen = 'FROZEN',
  ManualReview = 'MANUAL_REVIEW',
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Cancel = 'CANCEL',
}
